import React, {FC} from 'react';
import styled from 'styled-components';
import {useSlidePositionText} from '../../molecules/HorizontalSlider/hooks/useSliderA11y';

import {COLORS} from '../../../constants/colors';
import {
  ProductImage,
  ProductImageProps,
} from '../../molecules/ProductImage/ProductImage';

interface Props {
  next: () => void;
  prev: () => void;
  scrollToSlide: (index: number) => void;
  currentSlide: number;
  maxPages: number;
  prevIsActive: boolean;
  nextIsActive: boolean;
  images: Array<ProductImageProps>;
  className?: string;
}

export const ThumbnailNav: FC<Props> = ({
  currentSlide,
  className,
  images,
  scrollToSlide,
}) => {
  const getPositionText = useSlidePositionText();

  return (
    <Wrapper
      className={className}
      data-testid="ProductImageDetailsThumbnailNav"
    >
      {images.map((image, index) => {
        return (
          <ThumbnailNavItem
            data-testid="ProductImageDetailsThumbnailNavItem"
            key={`ProductImageDetails-thumbnail-${index}`}
          >
            <ThumbnailNavItemButton
              $isActive={currentSlide === index}
              aria-current={currentSlide === index}
              aria-label={getPositionText(index + 1, images.length)}
              data-testid="ProductImageDetailsThumbnailNavItemButton"
              onClick={() => scrollToSlide(index)}
            >
              <ProductImage
                {...image}
                columns={12}
                data-testid="ProductImageDetailsThumbnailImage"
              />
            </ThumbnailNavItemButton>
          </ThumbnailNavItem>
        );
      })}
    </Wrapper>
  );
};

export const THUMBNAIL_WIDTH = 84;
const Wrapper = styled.ul`
  align-items: center;
  display: flex;
  flex-direction: column;
  padding: 12px;
  box-sizing: border-box;
  width: ${THUMBNAIL_WIDTH}px;
  margin: 0;
  flex-shrink: 0;
  overflow-y: auto;

  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar-track {
    -webkit-box-shadow: none !important;
    background-color: transparent;
  }

  &::-webkit-scrollbar {
    display: none;
  }

  &::-webkit-scrollbar-thumb {
    background-color: transparent;
  }
`;

const ThumbnailNavItem = styled.li`
  list-style: none;
  margin-bottom: 9px;
  width: 100%;

  &:last-child {
    margin-bottom: 0;
  }
`;

const ThumbnailNavItemButton = styled.button<{$isActive: boolean}>`
  background-color: #f4f4f5;
  border: none;
  cursor: pointer;
  padding: 0;
  position: relative;
  width: 100%;
  border-radius: 4px;
  border: 1px solid;
  border-color: ${({$isActive}) => ($isActive ? COLORS.Black : 'transparent')};
`;
